import { useState, useEffect } from "react";

export const DEVICE = {
  MOBILE: "mobile",
  TAB: "tab",
  DESKTOP: "desktop",
};

const WINDOW_SIZE = {
  [DEVICE.MOBILE]: (size: number) => size <= 640,
  [DEVICE.TAB]: (size: number) => size > 640 && size <= 1007,
  [DEVICE.DESKTOP]: (size: number) => size > 1007,
};

export function useWindowSizeChanged() {
  const [device, setDevice] = useState<string | null>(null);
  useEffect(() => {
    const selectedDevice = Object.keys(WINDOW_SIZE).find((i: string) => {
      return WINDOW_SIZE[i](window.innerWidth);
    });
    if (selectedDevice) {
      setDevice(selectedDevice);
    }

    window.addEventListener("resize", () => {
      const selectedDeviceType = Object.keys(WINDOW_SIZE).find((i: string) =>
        WINDOW_SIZE[i](window.innerWidth)
      );
      if (selectedDeviceType) {
        setDevice(selectedDeviceType);
      }
    });
  }, []);
  return device;
}
